import { ROOT_ROLE } from "../../constants/user";

export const COMMON_ACTIVITY_CUSTOMER_IDS = [
  "peach_and_lily",
  "oofos",
  "goodchop",
  "cora",
  "goodr",
  "cleanboss",
  "brooklinen",
  "vincero",
] as const;

const allowedCustomers = new Set<string>(COMMON_ACTIVITY_CUSTOMER_IDS);

export const isCommonActivityCustomer = (
  customerId: string | null | undefined,
): customerId is (typeof COMMON_ACTIVITY_CUSTOMER_IDS)[number] =>
  !!customerId && allowedCustomers.has(customerId);

/** Resolve the tenant visible to this render, never from mutable browser storage. */
export const effectiveActivityCustomerId = ({
  actualRole,
  selectedCustomerId,
  userCustomerId,
}: {
  actualRole: string | null;
  selectedCustomerId: string | null;
  userCustomerId: string | null | undefined;
}): (typeof COMMON_ACTIVITY_CUSTOMER_IDS)[number] | null => {
  const effectiveCustomerId =
    actualRole === ROOT_ROLE ? selectedCustomerId : userCustomerId;
  return isCommonActivityCustomer(effectiveCustomerId)
    ? effectiveCustomerId
    : null;
};
